'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _roles = require('config/permissions/roles');

var _adminsByCategoryArea = require('./admins-by-category-area.component');

var _adminsByCategoryArea2 = _interopRequireDefault(_adminsByCategoryArea);

var _adminsByCategoryArea3 = require('./admins-by-category-area.service');

var _adminsByCategoryArea4 = _interopRequireDefault(_adminsByCategoryArea3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.reports.administrationsByCategoryArea', [_angularUiRouter2.default]).component('administrationsByCategoryArea', _adminsByCategoryArea2.default).service('AdminsByCategoryAreaService', _adminsByCategoryArea4.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('administrationsByCategoryArea', {
    parent: 'reports',
    url: '/administrations-by-category-area',
    component: 'administrationsByCategoryArea',
    data: {
      permissions: {
        only: [_roles.SYS_ADMIN],
        redirectTo: 'dashboard'
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/reports/admins-by-category-area/admins-by-category-area.module.js